module.exports = __webpack_public_path__ + "static/img/bn.4068e0ba.png";